import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box/Box';
import { Flex } from '../Flex/Flex';
const CustomBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ProgressBar__CustomBox",
  componentId: "sc-kr93mt-0"
})(["border-radius:2px;"]);
const defaultStepColor = 'background.light';
/**
 * @public
 */
export function ProgressBar({
  steps,
  currentStep,
  stepHeight = '4px',
  className
}) {
  return React.createElement(Flex, {
    className: className
  }, steps.map((step, index) => {
    const stepColor = index < currentStep ? steps[currentStep - 1].color : defaultStepColor;
    return React.createElement(CustomBox, {
      key: index,
      color: stepColor,
      height: stepHeight,
      width: 1,
      mr: 1,
      "data-testid": 'test-id-' + index
    });
  }));
}